import { Dropdown } from "@carbon/react";
import { useTranslation } from "react-i18next";

import { normalizeLanguage } from "../../../i18n";
import { LANGUAGES } from "../../../i18n/languages";
import "./selector.scss";

const LanguageFlag = ({ language }) => (
  <img
    alt=""
    aria-hidden="true"
    className="mm-language-selector__flag"
    src={language.flag}
  />
);

const LanguageSelector = () => {
  const { t, i18n } = useTranslation();
  const selectedLanguage = normalizeLanguage(
    i18n.resolvedLanguage || i18n.language
  );

  const languageOptions = LANGUAGES.map(({ id, code, labelKey, flag }) => ({
    id,
    code,
    flag,
    label: t(labelKey),
  }));
  const selectedLanguageOption = languageOptions.find(
    ({ id }) => id === selectedLanguage
  );

  const changeLanguage = ({ selectedItem }) => {
    if (selectedItem) {
      i18n.changeLanguage(selectedItem.id);
    }
  };

  return (
    <div className="mm-language-selector">
      <Dropdown
        aria-label={t("language.selectorLabel")}
        className="mm-language-selector__dropdown"
        hideLabel
        id="makemake-language-selector"
        itemToElement={(item) => (
          <span className="mm-language-selector__option">
            <LanguageFlag language={item} />
            <span>{item.label}</span>
          </span>
        )}
        itemToString={(item) => (item ? item.label : "")}
        items={languageOptions}
        label={t("language.selectorLabel")}
        onChange={changeLanguage}
        renderSelectedItem={(item) => (
          <span className="mm-language-selector__selected">
            <LanguageFlag language={item} />
            <span>{item.code}</span>
          </span>
        )}
        selectedItem={selectedLanguageOption}
        size="sm"
        titleText={t("language.selectorLabel")}
        type="inline"
      />
    </div>
  );
};

export default LanguageSelector;
